// src/components/ModeloCotizacion/ModeloCotizacion.jsx
import React from 'react';
import TagManager from 'react-gtm-module';
import styles from './ModeloCotizacion.module.scss';

const ModeloCotizacion = ({ modelo, onOpenCotizador }) => {
  const handleButtonClick = () => {
    if (typeof window !== 'undefined') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'ux_event',
          event_name: 'modelo_solicitar_cotizacion',
          event_category: 'engagement',
          event_label: `Solicitud de Cotización - ${modelo.nombre}`,
          value: null,
          slug: null
        },
      });
    }
    // Llamamos al handler que viene del padre
    onOpenCotizador();
  };

  return (
    <div className={styles.modeloCotizacion}>
      <button
        type="button"
        className={styles.modeloCotizacionButton}
        onClick={handleButtonClick}
      >
        COTIZAR
      </button>
    </div>
  );
};

export default ModeloCotizacion;
